module.exports = __webpack_public_path__ + "static/media/icon-checkmark-black.70519690.svg";